import React from 'react'
import { Route } from 'react-router-dom'
import SecurityQuestion from './SecurityQuestion'

import { securityQuestionRoot } from "../../../constants/routePaths"

const SecurityQuestionRoute = [
  <Route
    key="SecurityQuestion"
    exact path={securityQuestionRoot}
    component={SecurityQuestion}
  />,
];

export default SecurityQuestionRoute